import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function Help (props) {
  const [strings] = useEnvValue('strings')
  const [helpLink] = useEnvValue('planting.helpLink')

  const title = strings.planting.help.title
  const description = strings.planting.help.description
  const readMore = strings.planting.help.readMore

  return (
    <div className='hedge-plant__content-row row-help'>
      {
        title !== '' && description !== '' && readMore !== ''
          ? <>
              <div className="help-title">{title}</div>
              <div className="help-description">{description}</div>
              <div className="help-link">
              {
                helpLink !== null && helpLink.hasOwnProperty('url') && helpLink.hasOwnProperty('target')
                  ? <a href={helpLink.url} target={helpLink.target}>{readMore}</a>
                  : null
              }
            </div>
          </>
      : null
      }
    </div>
  )
}

export default observer(Help)